(() => {
  if (window.DailyRadianceLanding) return;
  window.DailyRadianceLanding = true;

  const initProductForm = (form) => {
    const select = form.querySelector('[data-dr-variant]');
    if (!select || select.dataset.drReady) return;
    select.dataset.drReady = 'true';

    const update = () => {
      const option = select.options[select.selectedIndex];
      const root = form.closest('[data-dr-offer]');
      const submit = form.querySelector('[data-dr-submit]');
      const label = form.querySelector('[data-dr-submit-label]');
      const available = option.dataset.available === 'true';

      root?.querySelectorAll('[data-dr-price]').forEach((node) => { node.textContent = option.dataset.price || ''; });
      root?.querySelectorAll('[data-dr-compare]').forEach((node) => {
        node.textContent = option.dataset.comparePrice || '';
        node.hidden = !option.dataset.comparePrice;
      });
      document.querySelectorAll('[data-dr-sticky-price]').forEach((node) => { node.textContent = option.dataset.price || ''; });
      if (submit) submit.disabled = !available;
      if (label) label.textContent = available ? label.dataset.defaultLabel || label.textContent : 'Sold out';
    };

    const label = form.querySelector('[data-dr-submit-label]');
    if (label) label.dataset.defaultLabel = label.textContent.trim();
    select.addEventListener('change', update);
    update();
  };

  const initSticky = (sticky) => {
    if (sticky.dataset.drReady) return;
    sticky.dataset.drReady = 'true';
    const selector = sticky.dataset.trigger;
    const trigger = selector ? document.querySelector(selector) : null;
    if (!trigger || !('IntersectionObserver' in window)) {
      sticky.classList.add('is-visible');
      return;
    }
    const observer = new IntersectionObserver(([entry]) => sticky.classList.toggle('is-visible', !entry.isIntersecting), { threshold: 0 });
    observer.observe(trigger);
  };

  const init = (scope = document) => {
    scope.querySelectorAll('[data-dr-product-form]').forEach(initProductForm);
    scope.querySelectorAll('[data-dr-sticky]').forEach(initSticky);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();

